// extracted by mini-css-extract-plugin
export default {"placeholder":"Placeholder_placeholder__R44U6","shine":"Placeholder_shine__E6fTa"};